module.exports = __webpack_public_path__ + "img/icons8-whatsapp.2cc4c3e7.svg";